module.exports = __webpack_public_path__ + "img/company.2af4c402.png";